import { render, staticRenderFns } from "./FlightTicketPreviewPanel.vue?vue&type=template&id=b2d7da02&scoped=true&"
import script from "./FlightTicketPreviewPanel.vue?vue&type=script&lang=js&"
export * from "./FlightTicketPreviewPanel.vue?vue&type=script&lang=js&"
import style0 from "./FlightTicketPreviewPanel.vue?vue&type=style&index=0&id=b2d7da02&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d7da02",
  null
  
)

export default component.exports